import type { TCatFormDataInput } from "@./suf-store";
import { calculateCatBirthday } from "./catTransforms";

export const normaliseCatFormDataForCheckout = (catData: TCatFormDataInput): TCatFormDataInput => ({
  ...catData,
  name: catData.name?.trim(),
  birthday: catData.birthday ?? calculateCatBirthday(catData),
});

export const normaliseCatsFormDataForCheckout = (
  cats: Record<string, TCatFormDataInput>,
): Record<string, TCatFormDataInput> => {
  const normalisedCats: Record<string, TCatFormDataInput> = {};
  Object.entries(cats).forEach(([ key, data ]) => {
    normalisedCats[key] = normaliseCatFormDataForCheckout(data);
  });

  return normalisedCats;
};
